/**
 * A link to a certain page, an anchor tag
 */

import styled from 'styled-components';

const A = styled.a`
  color: #3f51b5;

  &:hover {
    color: #6cc0e5;
    cursor: pointer;
  }
`;

export default A;
